import { IAllPrivateRoutes } from "components/routes/app_routes";
import { user } from "config/roles";
import { ReceiverCreationScreen } from "../screens";

export const receiverRoutes: IAllPrivateRoutes[] = [
  { label: "Home", pathName: "/client", routeElement: ReceiverCreationScreen, roles: user.roles },
];
